var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.length>0)?_c('div',{staticClass:"imgs"},_vm._l((_vm.list),function(i,index){return _c('img',{key:index,attrs:{"src":i,"alt":""},on:{"click":function($event){return _vm.maskShow(i)}}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }